export var Types;
(function (Types) {
    Types[Types["SEND_CODE"] = 0] = "SEND_CODE";
    Types[Types["VERIFY_CODE"] = 1] = "VERIFY_CODE";
    Types[Types["SENT_CODE"] = 2] = "SENT_CODE";
    Types[Types["VERIFIED_CODE"] = 3] = "VERIFIED_CODE";
    Types[Types["ERROR"] = 4] = "ERROR";
})(Types || (Types = {}));
//# sourceMappingURL=index.js.map